import {
  getUserProfileFailure,
  getUserProfileRequest,
  getUserProfileSuccess,
  connectInititativeRequest,
  connectInititativeSuccess,
  connectInititativeFailure,
  setNeedToLinkInitiative,
} from './actionCreator';

import { connectInitiativeById, getProfile } from './api.service';

// Id of the most recent getUserProfile() call; responses from older calls are discarded.
let latestProfileRequestId = 0;

/**
 * Fetch the user's profile, including the role and permissions scoped to the given initiative.
 * Only the most recent call's response is applied.
 *
 * @param {string|null} initiativeId - The initiative to scope the profile to, if any
 * @returns {Function}
 */
export const getUserProfile = (initiativeId) => async (dispatch) => {
  latestProfileRequestId += 1;
  const requestId = latestProfileRequestId;
  dispatch(getUserProfileRequest());
  try {
    const { data } = await getProfile(initiativeId ? { initiative_id: String(initiativeId) } : {});
    if (requestId !== latestProfileRequestId) return;
    localStorage.setItem('user', JSON.stringify(data.data));
    localStorage.setItem('permissions', JSON.stringify(data.data.permissions));
    dispatch(getUserProfileSuccess(data.data));
  } catch ({ message }) {
    if (requestId !== latestProfileRequestId) return;
    dispatch(getUserProfileFailure(message));
  }
};

export const updateNeedToLinkInitiative = (userId) => async (dispatch) => {
  if (userId) localStorage.setItem('userIdForLinkNewInitiative', userId);
  if (!userId) localStorage.removeItem('userIdForLinkNewInitiative');
  dispatch(setNeedToLinkInitiative(userId));
};

export const connectInitiative = (userId) => async (dispatch) => {
  dispatch(connectInititativeRequest());
  try {
    const { data } = await connectInitiativeById(userId);
    dispatch(connectInititativeSuccess(data));
    dispatch(updateNeedToLinkInitiative(null));
  } catch ({ message }) {
    dispatch(connectInititativeFailure(message));
  }
};
